import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import Svg from "../Svg";
var Icon = function(props) {
    return /*#__PURE__*/ _jsxs(Svg, _object_spread_props(_object_spread({
        width: "20",
        height: "19",
        viewBox: "0 0 20 19"
    }, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M16 18.1458L14.3542 16.4792C13.7292 16.9792 13.0451 17.3576 12.3021 17.6146C11.559 17.8715 10.7917 18 10 18C9.02778 18 8.11806 17.816 7.27083 17.4479C6.42361 17.0799 5.68403 16.5799 5.05208 15.9479C4.42014 15.316 3.92014 14.5764 3.55208 13.7292C3.18403 12.8819 3 11.9722 3 11C3 10.2083 3.12847 9.44097 3.38542 8.69792C3.64236 7.95486 4.02083 7.27083 4.52083 6.64583L1.875 4L2.9375 2.9375L17.0625 17.0833L16 18.1458ZM7.5 3V1.5H12.5V3H7.5ZM16.25 14.1458L10.7708 8.64583L10.75 7H9.25V7.125L6.875 4.75C7.36111 4.48611 7.86806 4.29514 8.39583 4.17708C8.92361 4.05903 9.45833 4 10 4C10.8056 4 11.5833 4.13542 12.3333 4.40625C13.0833 4.67708 13.7708 5.0625 14.3958 5.5625L15.4792 4.47917L16.5208 5.54167L15.4583 6.625C15.9583 7.25 16.3403 7.9375 16.6042 8.6875C16.8681 9.4375 17 10.2083 17 11C17 11.5417 16.9375 12.0799 16.8125 12.6146C16.6875 13.1493 16.5 13.6597 16.25 14.1458Z",
                fill: "#9F9DAE"
            }),
            " "
        ]
    }));
};
export default Icon;
